import $ from 'jquery';

export default class MeganavMenu {
  constructor(el) {
    this.$el = $(el);

    this.$el.on('click.meganav-menu', '.meganav-menu-header', event => {
      const $header = $(event.currentTarget);

      if (!$header.hasClass('meganav-menu-empty')) {
        event.preventDefault();
        this.toggleList($header);
      }
    });
  }

  unload() {
    this.$el.off('.meganav-menu');
  }

  toggleList($header, state) {
    const $group = $header.parents('.meganav-menu-group');
    const $list = $group.find('.meganav-menu-items');

    $group.toggleClass('meganav-menu-active', state);
    $list.slideToggle(state);
  }
}
